<script>
    import { Scatter } from 'vue-chartjs'

    export default {
        extends: Scatter,
        props: ['datasets', 'xlabel', 'ylabel'],
        computed: {
            'chartdata': function () {
                return {
                    datasets: this.datasets
                }
            }
        },
        mounted() {
            this.renderChart(this.chartdata,
                {responsive: true, maintainAspectRatio: false, scales: {
                xAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: this.xlabel
                    }
                }],
                    yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: this.ylabel
                    }
                }]
            }})
        }
    }
</script>